export default Object.freeze({
  list: [],
  info: {},
  logs: {},
});
